<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M9.33341 1.5127V4.26639C9.33341 4.63976 9.33341 4.82644 9.40608 4.96905C9.46999 5.09449 9.57198 5.19648 9.69742 5.26039C9.84003 5.33305 10.0267 5.33305 10.4001 5.33305H13.1538M6.33341 7.99967L9.66675 11.333M9.66675 7.99967L6.33341 11.333M9.33341 1.33301H5.86675C4.74664 1.33301 4.18659 1.33301 3.75877 1.55099C3.38244 1.74274 3.07648 2.0487 2.88474 2.42503C2.66675 2.85285 2.66675 3.4129 2.66675 4.53301V11.4663C2.66675 12.5864 2.66675 13.1465 2.88474 13.5743C3.07648 13.9506 3.38244 14.2566 3.75877 14.4484C4.18659 14.6663 4.74664 14.6663 5.86675 14.6663H10.1334C11.2535 14.6663 11.8136 14.6663 12.2414 14.4484C12.6177 14.2566 12.9237 13.9506 13.1154 13.5743C13.3334 13.1465 13.3334 12.5864 13.3334 11.4663V5.33301L9.33341 1.33301Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
